import http from "./httpService";
import config from "./../config.json";
import { getBase64 } from "../utils/stringUtils";

let apiEndpoint = process.env.REACT_APP_API_URL || config.apiUrl;
apiEndpoint += "taxes";

export const saveAccountTaxAsync = async (id, data) => {
  const files = [];

  if (typeof data.files !== "undefined")
    for (let i = 0; i < data.files.length; i++) {
      const file = await getBase64(data.files[i]);
      const content = file.split(",")[1];
      files.push({
        file_name: data.files[i].name,
        content,
      });
    }

  const cor_id = data.cor && data.cor !== undefined ? data.cor.value : null;

  const tax = { ...data };
  tax["certificate_of_registration_id"] = cor_id;
  tax["tax_type"] = data.tax_type.value;
  tax["return_period"] = data.return_period.value;
  tax["return_period_type"] = data.return_period_type.value;
  tax["year"] = data.year.slice(data.year.length - 4);
  tax["files"] = files;

  if (tax.id) return await http.put(`${apiEndpoint}/${tax.id}`, tax);
  return await http.post(`${apiEndpoint}/${id}`, tax);
};

export const saveTaxpayerInfoAsync = async (data) => {
  const taxpayer = { ...data };
  taxpayer["revenue_district_office"] =
    typeof taxpayer.revenue_district_office.value !== undefined
      ? taxpayer.revenue_district_office.value
      : null;

  return await http.put(`${apiEndpoint}/accounts/${taxpayer.id}`, taxpayer);
};

export const saveAccountCreditableAsync = async (item) => {
  if (item.id) {
    const url = `${apiEndpoint}/creditable-withholding-taxes`;
    const { data } = await http.put(url, item);
    return data.result;
  }

  const url = `${apiEndpoint}/creditable-withholding-taxes/${item.account_id}`;
  const { data } = await http.post(url, item);
  return data.result;
};

export const saveAccountReceiptAsync = async (item) => {
  if (item.id) {
    const url = `${apiEndpoint}/official-receipts`;
    const { data } = await http.put(url, item);
    return data.result;
  }

  const url = `${apiEndpoint}/official-receipts/${item.account_id}`;
  const { data } = await http.post(url, item);
  return data.result;
};

export const sendFileEmailAsync = async (id) => {
  return await http.post(`${apiEndpoint}/resend-email/${id}`);
};

export const deleteCreditableAsync = async (id) => {
  const url = `${apiEndpoint}/creditable-withholding-taxes/${id}`;
  return await http.delete(url);
};

export const deleteReceiptAsync = async (id) => {
  const url = `${apiEndpoint}/official-receipts/${id}`;
  return await http.delete(url);
};

export const getAccountTaxesAsync = async (id, params) => {
  const {
    sort_column,
    search_query: query,
    current_page: page,
    page_size: size,
  } = params;

  const { path: column, order } = sort_column;
  const url = `${apiEndpoint}/${id}?q=${query}&column=${column}&order=${order}&p=${page}&s=${size}`;

  const { data } = await http.get(url);
  return data;
};

export const getCreditablesAsync = async (params) => {
  const {
    year,
    quarter,
    is_verified,
    sort_column,
    size,
    search_query: query,
    current_page: page,
  } = params;

  const { path: column, order } = sort_column;
  const url = `${apiEndpoint}/creditable-withholding-taxes?q=${query}&year=${year}&quarter=${quarter}&verified=${is_verified}&column=${column}&order=${order}&p=${page}&s=${size}`;

  const { data } = await http.get(url);
  return data;
};

export const getReceiptsAsync = async (params) => {
  const {
    year,
    quarter,
    is_verified,
    sort_column,
    size,
    search_query: query,
    current_page: page,
  } = params;

  const { path: column, order } = sort_column;
  const url = `${apiEndpoint}/official-receipts?q=${query}&year=${year}&quarter=${quarter}&verified=${is_verified}&column=${column}&order=${order}&p=${page}&s=${size}`;

  const { data } = await http.get(url);
  return data;
};

export const getAccountCreditablesAsync = async (id, params) => {
  const {
    year,
    quarter,
    sort_column,
    size,
    search_query: query,
    current_page: page,
  } = params;

  const { path: column, order } = sort_column;
  const url = `${apiEndpoint}/creditable-withholding-taxes/${id}?q=${query}&year=${year}&quarter=${quarter}&column=${column}&order=${order}&p=${page}&s=${size}`;

  const { data } = await http.get(url);
  return data;
};

export const getAccountReceiptsAsync = async (id, params) => {
  const {
    year,
    quarter,
    sort_column,
    size,
    search_query: query,
    current_page: page,
  } = params;

  const { path: column, order } = sort_column;
  const url = `${apiEndpoint}/official-receipts/${id}?q=${query}&year=${year}&quarter=${quarter}&column=${column}&order=${order}&p=${page}&s=${size}`;

  const { data } = await http.get(url);
  return data;
};

export const getTaxpayerInfoAsync = async (id) => {
  const { data } = await http.get(`${apiEndpoint}/accounts/${id}`);
  return data.result;
};

export const getRevenueDistrictOfficesAsync = async () => {
  const { data } = await http.get(`${apiEndpoint}/rdos`);
  return data.result;
};

export const getTaxTypes = () => {
  return [
    { value: 1, label: "Income Tax" },
    { value: 2, label: "Percentage Tax" },
    { value: 3, label: "Value Added Tax" },
    { value: 4, label: "Registration Fee" },
    { value: 5, label: "Withholding Tax" },
    { value: 6, label: "Expanded Withholding Tax" },
  ];
};

export const getPeriodTypes = () => {
  return [
    { value: 1, label: "Monthly" },
    { value: 2, label: "Quarterly" },
    { value: 3, label: "Annual" },
  ];
};

export const getTaxQuarters = () => {
  return [
    { value: 1, label: "Q1" },
    { value: 2, label: "Q2" },
    { value: 3, label: "Q3" },
    { value: 4, label: "Q4 / Annual" },
  ];
};

export const getAltTaxQuarters = () => {
  return [
    { value: 1, label: "1st Quarter" },
    { value: 2, label: "2nd Quarter" },
    { value: 3, label: "3rd Quarter" },
    { value: 4, label: "4th Quarter" },
  ];
};

export const getClientTypes = () => {
  return [
    { value: 1, label: "Corporate" },
    { value: 2, label: "Individual" },
    { value: 3, label: "Senior Citizen" },
    { value: 4, label: "PWD" },
  ];
};

export const getReturnPeriods = (period_type) => {
  if (period_type === 1)
    return [
      { value: 1, label: "January" },
      { value: 2, label: "February" },
      { value: 3, label: "March" },
      { value: 4, label: "April" },
      { value: 5, label: "May" },
      { value: 6, label: "June" },
      { value: 7, label: "July" },
      { value: 8, label: "August" },
      { value: 9, label: "September" },
      { value: 10, label: "October" },
      { value: 11, label: "November" },
      { value: 12, label: "December" },
    ];

  return [
    { value: 1, label: "Q1" },
    { value: 2, label: "Q2" },
    { value: 3, label: "Q3" },
    { value: 4, label: "Q4 / Annual" },
  ];
};

export const getSelectedTaxQuarter = (quarter) => {
  let option;

  switch (quarter) {
    case 1:
      option = { value: 1, label: "Q1" };
      break;
    case 2:
      option = { value: 2, label: "Q2" };
      break;
    case 3:
      option = { value: 3, label: "Q3" };
      break;
    case 4:
      option = { value: 4, label: "Q4 / Annual" };
      break;
    default:
      option = null;
  }

  return option;
};

export const taxService = {
  saveAccountTaxAsync,
  saveTaxpayerInfoAsync,
  saveAccountCreditableAsync,
  saveAccountReceiptAsync,
  sendFileEmailAsync,
  deleteCreditableAsync,
  deleteReceiptAsync,
  getAccountTaxesAsync,
  getCreditablesAsync,
  getReceiptsAsync,
  getAccountCreditablesAsync,
  getAccountReceiptsAsync,
  getTaxpayerInfoAsync,
  getRevenueDistrictOfficesAsync,
  getTaxTypes,
  getTaxQuarters,
  getAltTaxQuarters,
  getClientTypes,
  getPeriodTypes,
  getReturnPeriods,
  getSelectedTaxQuarter,
};

export default taxService;
